import React from 'react';

function CookiesComp() {
  const cookiesInfo = [
    {
      heading: "What Are Cookies?",
      paragraph:
        "Cookies are small data files stored on your device to improve browsing experience and functionality.",
    },
    {
      heading: "Types of Cookies We Use",
      points: [
        "Essential Cookies: Enable core functionality (e.g., login, checkout)",
        "Performance Cookies: Help us understand user interaction via analytics",
        "Functionality Cookies: Remember your preferences and custom settings",
        "Advertising Cookies: Show personalized advertisements based on your interests (only if consented)",
      ],
    },
    {
      heading: "Managing Cookies",
      paragraph:
        "You can manage or disable cookies through your browser settings. However, some website features may not function properly if cookies are disabled.",
    },
    {
      heading: "Third-Party Cookies",
      paragraph:
        "We may use cookies from trusted third parties such as Google Analytics, Stripe, and Meta for performance and marketing insights.",
    },
  ];

  return (
    <section className="sec_pd mb-5 mt-5">
      <h3 className="text-black mb-4">Cookies Policy</h3>

      {cookiesInfo.map((item, idx) => (
        <div key={idx} className="mb-4">
          <p className="text-black fw-bold mt-4">{idx + 1}. {item.heading}</p>

          {item.paragraph && (
            <p className="text-muted">{item.paragraph}</p>
          )}

          {item.points && (
            <ul className="text-muted list-disc list-inside ml-4 mt-2">
              {item.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </section>
  );
}

export default CookiesComp;
